import { render, staticRenderFns } from "./acompanharViagem.vue?vue&type=template&id=06be8ab4"
import script from "./acompanharViagem.vue?vue&type=script&lang=js"
export * from "./acompanharViagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports